'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import ProductCatalogModal from 'ui-addon-upgrades/_core/productCatalog/ProductCatalogModal';
import { allProductsSelector } from '../../../selectors/SelectorUtils';

const FeatureModalSSAPI = ({
  onCloseClick,
  productLine,
  defaultProductLevel
}) => {
  const allProducts = useSelector(allProductsSelector);
  return /*#__PURE__*/_jsx(ProductCatalogModal, {
    onCloseClick: onCloseClick,
    productMap: allProducts,
    productLine: productLine,
    defaultProductLevel: defaultProductLevel
  });
};

export default FeatureModalSSAPI;